import {Injectable} from '@angular/core';
import {Headers, Http, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {CandidatureFormation} from './candidature-formation.model';
import {Commission} from '../commission';

import {CONSTANTS} from "../../cadens.constants";
import {CandidatureFormationOrder} from "./candidature-formation-order.model";
import {EntityVerification} from "./entity-verification.model";
import {Question} from "../formation";

@Injectable()
export class CandidatureFormationService {

    private resourceUrl = 'api/candidature-formations';
    private resourceQuestionUrl = 'api/candidature-formations/questions';
    private candidatureOrdreUrl = 'api/candidature-formations-order';
    private resourceReinscritsUrl = 'api/lastFormation';
    private resourceCommissions = 'api/candidature-formations/commissions';
    private resourceVerification = 'api/candidature-formations/verification';
    private generatepdf = '/generatepdf';
    private genererContratEtudeInternationalUrl = '/genererContratEtudeInternational';
    private genererLettreAdmissionUrl = '/genererLettreAdmission';
    private status = '-status';
    private statusLot = '-status-lots';
    private order = '-order';

    public exportPdfNormal = 1;
    public exportPdfRentree = 2;

    constructor(private http: Http) {
    }

    create(candidature: CandidatureFormation): Observable<CandidatureFormation> {
        let copy: CandidatureFormation = Object.assign({}, candidature);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(candidatureFormation: CandidatureFormation, forceTransmit: Boolean, fullValidation: Boolean): Observable<CandidatureFormation> {
        let copy: CandidatureFormation = Object.assign({}, candidatureFormation);
        copy.dateModification = new Date();
        return this.http.put(`${this.resourceUrl}/${forceTransmit}/${fullValidation}`, copy).map((res: Response) => {
            return res.json();
        });
    }

    verifierCandidature(candidatureFormationId: number, envoyerException: Boolean): Observable<EntityVerification> {
        return this.http.get(`${this.resourceVerification}/${candidatureFormationId}/${envoyerException}`).map((res: Response) => {
            return res.json();
        });
    }


    updateCandidaturesStatus(candidatureFormations: CandidatureFormation[], options: any) {
        let copy: CandidatureFormation[] = candidatureFormations.splice(0);
        copy.forEach(cf => {
            cf.dateModification = new Date();

            //ajout du choix du user: attestation honneur ou de démission
            if (options && options.choix) {
                cf.choixConfirmation =options.choix;
            }
            if (options && options.response) {
                cf.response = options.response;
                if(options.response == CONSTANTS.AWAITING) {
                    // Propose en LC on copy l'avis rang à la reponseRang
                    cf.responseRang = cf.avisRang;
                }
            }
            if (options && options.avis) {
                cf.avis = options.avis;
            }
            if (options && options.commentaire) {
                cf.commentaire = options.commentaire;
            }
            if (options && options.avisRang) {
                cf.avisRang = options.avisRang;
            }
            if (options && options.conforme) {
                cf.conforme = options.conforme;
            }
            if (options && options.statut) {
                cf.statut = options.statut;
                if (options.statut==CONSTANTS.DESISTED){
                    cf.dateDesistement=new Date();
                }else if (options.statut==CONSTANTS.CONFIRMED) {
                    cf.dateConfirmation=new Date();
                }
            }
            if (options && options.vidageLc) {
                cf.responseRang = null;
            }
        });

        // AMU: 26/02/2026: Tri si options.response == CONSTANTS.AWAITING
        // Lors que l'on valide par lot, le rang est recalculé dans recalculRangListeComplementaire(CandidatureFormation candidatureFormation, Integer oldRang)
        //il faut traiter toutes les LC en même temps pour que avisRang soit le même quand on le copie dans reponseRang, dans le cas contraire le rang est recalculé et peut être
        // différent de celui présent dans avisRang.
        // Si des candidatures ont déjà des données dans reponseRang, les nouveaux rangs seront recalculés en fonction des rangs existant.
        // par exemple: si avisrang = 4 pour la formationId= 99 et qu'aucun rang n'est saisi pour la formationId=99, le recalcul sauvegardera le reponseRang = 1.
        if (options && options.response == CONSTANTS.AWAITING) {
            copy.sort((a, b) => {
                // Tri par formationId
                if (a.formationId < b.formationId) return -1;
                if (a.formationId > b.formationId) return 1;

                // Si formationId est égal, tri par avisRang (si non null)
                if (a.avisRang === null) return 1;
                if (b.avisRang === null) return -1;
                return a.avisRang - b.avisRang;
            });
        }
        if (options && options.response) {
            if(copy.length > 1){
                console.log("RESPONSE: candidatureFormations.length > 1 = > candidatureFormationResource.updateStatusCandidatureFormationParLot");
                return this.http.put(this.resourceUrl + this.statusLot, copy).map((res: Response) => {
                    return res.json();
                });
            } else {
                console.log("RESPONSE: candidatureFormations.length = 1 = > candidatureFormationResource.updateStatusCandidatureFormation");
                return this.http.put(this.resourceUrl + this.status, copy).map((res: Response) => {
                    return res.json();
                });
            }
        } else{
            console.log("OTHER OPTIONS: candidatureFormations.length = 1 = > candidatureFormationResource.updateStatusCandidatureFormation");
            return this.http.put(this.resourceUrl + this.status, copy).map((res: Response) => {
                return res.json();
            });
        }
        /*if(copy.length > 1){
            console.log("candidatureFormations.length > 1 = > candidatureFormationResource.updateStatusCandidatureFormationParLot");
            return this.http.put(this.resourceUrl + this.statusLot, copy).map((res: Response) => {
                return res.json();
            });
        } else {
            console.log("candidatureFormations.length = 1 = > candidatureFormationResource.updateStatusCandidatureFormation");
            return this.http.put(this.resourceUrl + this.status, copy).map((res: Response) => {
                return res.json();
            });
        }*/
    }

    updateCandidaturesOrder(candidatureFormations: CandidatureFormationOrder[]) : Observable<CandidatureFormationOrder> {
        let orderList: CandidatureFormationOrder[] = [];
        candidatureFormations.forEach(candidatureFormations => {
            let orderModifie = new CandidatureFormationOrder();
            orderModifie.id=candidatureFormations.id ;
            orderModifie.ordre=candidatureFormations.ordre ;
            orderList.push(orderModifie) ;
        });
        return this.http.put(this.resourceUrl + this.order, orderList).map((res: Response) => {
            return res.json();
        });
    }


    /**
     * Generate the PDF file of ONE candidature from the candidatureFormation ID
     */
    generatePDF(id: number, isUser: boolean, pdfType: Number ): Observable<any> {
        let params = new URLSearchParams();
        params.set('isUser', isUser + '');
        params.set('pdfType', pdfType + '');
        return this.http.get(this.resourceUrl + '/' + id + this.generatepdf,
            {search: params, responseType: ResponseContentType.Blob}).map(
            (res) => {
                return new Blob([res.blob()], {type: 'application/pdf'});
            });
    }


    /**
     * Generate the ZIP of the pdf files of EACH candidatures from the candidatureFormation IDs
     */
    generatePDFs(ids: number[], isUser: boolean, pdfType: Number ): Observable<any> {
        let params = new URLSearchParams();
        params.set('isUser', isUser + '');
        params.set('pdfType', pdfType + '');
        params.set('ids', ids + '');

        let headers = new Headers();
        headers.append('Content-Type', 'application/zip; charset=utf-8');
        headers.append('Accept', 'application/zip');
        return this.http.get(this.resourceUrl + this.generatepdf,
            {
                // headers: headers,
                search: params,
                responseType: ResponseContentType.Blob
            }).map(
            (res: Response) => new Blob([res.blob()], {type: 'application/zip'}));
    }

    find(id: number, recalculateEi: Boolean): Observable<CandidatureFormation> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('recalculateEi', recalculateEi.toString());
        return this.http.get(`${this.resourceUrl}/${id}`, {search: params}).map((res: Response) => {
            return res.json();
        });
    }

    findQuestions(candidatureId: number): Observable<Question> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('candidatureId', candidatureId.toString());
        return this.http.get(`${this.resourceQuestionUrl}/${candidatureId}`, {search: params}).map((res: Response) => {
            return res;
        });
    }


    findLastFormationENS(id: number): Observable<string> {
        return this.http.get(`${this.resourceReinscritsUrl}/${id}`).map((res: Response) => {
            return res.text();
        });
    }

    findCommissionPourCandidature( ouverteUniquement:boolean , candidatureFormationId: number): Observable<Commission[]> {
        return this.http.get(`${this.resourceCommissions}/${ouverteUniquement}/${candidatureFormationId}`).map((res: Response) => {
            return res.json();
        });
    }



    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.referentId) {
            params.set('referentId', req.referentId);
        }
        if (req && req.enseignantId) {
            params.set('enseignantId', req.enseignantId);
        }
        if (req && req.statut) {
            params.set('statut', req.statut);
        }
        if (req && req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        /*if (req && req.dateSuppression != null) {
         *  // params.set('dateSuppression', req.dateSuppression);
        }*/
        if (req && req.dateSuppression) {
            params.set('dateSuppression', req.dateSuppression);
        } else {
            params.set('dateSuppression', false.toString());
        }
        return this.http.get(this.resourceUrl, {search: params});
    }

    findCandidatureOrdre(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.candidatureOrdreUrl, {search: params});
    }


    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }


    /**
     * Genere le contrat d'étude pour echange international
     */
    genererContratEtudeInternational(id: number): Observable<any> {
        return this.http.get(this.resourceUrl + '/' + id + this.genererContratEtudeInternationalUrl,
            {responseType: ResponseContentType.Blob}).map(
            (res) => {
                return new Blob([res.blob()], {type: 'application/pdf'});
            });
    }

    /**
     * Genere la lettre d'admission
     */
    genererLettreAdmission(id: number, pourReponseCode:string, sortieListeComplementaire : Boolean): Observable<any> {
        let params = new URLSearchParams();
        params.set('sortieLC', sortieListeComplementaire==true?"true":"false" );
        params.set('pourReponseCode', pourReponseCode );
        return this.http.get(this.resourceUrl + '/' + id + this.genererLettreAdmissionUrl ,
            {search: params, responseType: ResponseContentType.Blob}).map(
            (res) => {
                return new Blob([res.blob()], {type: 'application/pdf'});
            });
    }

    //Renvoi vrai si la candidature est echange international
    public static isCandidatureEchange(candi: CandidatureFormation): boolean {
        return candi.formationId === CONSTANTS.ECHANGE_INTERNATIONAL_ID;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-formation.service.ts